<template>
<div>
    
    <b-table ref="tbl"
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        v-model="value"
        :per-page="perPage"
        :current-page="currentPage">

            <template v-slot:cell(status)="data" >
                <div @click="onStatusClick(data.item.deviceId)">
                    <badge
                        v-if="statuses[data.item.deviceId] && statuses[data.item.deviceId].indexOf('ON') == 0"
                        :title="statuses[data.item.deviceId].split(';')[1].slice(0, -4)"
                        type="success">{{$t('button.on')}}</badge>
                    <badge
                        v-else-if="statuses[data.item.deviceId] && statuses[data.item.deviceId].indexOf('OFF') == 0"
                        :title="statuses[data.item.deviceId].split(';')[1].slice(0, -4)"
                        type="danger">{{$t('button.off')}}</badge>
                    <badge
                        v-else
                        :title="statuses[data.item.deviceId] ? statuses[data.item.deviceId].split(';')[1].slice(0, -4) : ''"
                        type="default">?</badge>
                </div>
            </template>
            
            <template v-slot:cell(controller)="data">
                <span v-for="infopoint in data.item.controlInfopoints" :key="infopoint" style="display: block;">{{ infopoint }}</span>
            </template>
            <template v-slot:cell(controlled)="data">
                <span v-for="device in data.item.slaveDevices" :key="device" style="display: block;">{{ deviceName(device) }}</span>
            </template>
    </b-table>

    <TablePagination 
        :total-rows="totalRows" 
        :per-page="perPage" 
        :currentPage="currentPage"
        @pageChange="onPageChange">
    </TablePagination>
</div>
</template>

<script>

import powerSocket from '@/store/displays/powerSocket'
import device from '@/store/displays/device'

export default {
    props: ['filter'],
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            statusUpdater: null,
            value: null
        }
    },
    computed: {
        fields() {
            return [
                { key: "status", label: this.$t('powersockets.status') },
                { key: "name", label: this.$t('powersockets.name') },
                { key: "description", label: this.$t('powersockets.description') },
                { key: "type", label: this.$t('powersockets.type') },
                { key: "ip", label: this.$t('powersockets.ip') },
                { key: "controller", label: this.$t('powersockets.controller') },
                { key: "controlled", label: this.$t('powersockets.controlled') }
            ];
        },
        items() {

            if( this.filter == null ) {
                return this.$store.state.powerSocket.powerSocketList
            }

            return this.$store.state.powerSocket.powerSocketList.filter((socketti) => {
         
                return (socketti.name && socketti.name.toLowerCase().includes(this.filter.toLowerCase())) ||
                (socketti.description && socketti.description.toLowerCase().includes(this.filter.toLowerCase())) ||
                (socketti.slaveDevices && socketti.slaveDevices.find( item => this.deviceName(item).toLowerCase().includes(this.filter.toLowerCase()) ) != undefined) ||
                (socketti.controlInfopoints && socketti.controlInfopoints.find ( item => item.toLowerCase().includes(this.filter.toLowerCase()) ) != undefined) ||
                (socketti.type && socketti.type.toLowerCase().includes(this.filter.toLowerCase())) ||
                (socketti.ip && socketti.ip.toLowerCase().includes(this.filter.toLowerCase())) ||
                (socketti.description && socketti.description.toLowerCase().includes(this.filter.toLowerCase()))
                
            })

        },
        statuses() {
            return this.$store.state.powerSocket.powerSocketStatuses;
        },
        totalRows() {
            return this.items ? this.items.length : 0;
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.powerSocket) {
            this.$store.registerModule("powerSocket", powerSocket);
        }
        this.$store.dispatch('powerSocket/getPowerSocketList');
        if (!this.$store.state.device) {
            this.$store.registerModule("device", device);
        }
        this.$store.dispatch('device/getDeviceList');
      
    },

    mounted: function() {
        this.getShownRowsStatuses(this)
    },
    created(){
         this.updateStatuses();
    },
    beforeDestroy(){
        clearTimeout(this.statusUpdater);
    },
    methods: {
        onRowSelected(items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {
            this.currentPage = 1;
            
            if(filteredItems.length == 1){
                setTimeout(() => {
                    const row = this.$refs.tbl.$el
                              .getElementsByTagName('tbody')[0]
                              .getElementsByTagName('tr')[0]
                    if(row) row.click();

                 }, 100);
            }
        },
        onPageChange(page) {
            this.currentPage = page
            this.getShownRowsStatuses(this)
        },
        onStatusClick(deviceId) {
            this.$store.dispatch('powerSocket/sendCommand', { deviceId: deviceId, command: 'STATUS' });
            const vm = this;
            this.getShownRowsStatuses(vm);
        },
        deviceName(device) {
            var d = this.$store.getters['device/getDeviceById'](device);
            if (d && d.name) {
                return d.name;
            } else {
                return '';
            }
        },
        updateStatuses(){
            if(this.items.length > 0)
                this.$store.dispatch('powerSocket/getPowerSocketStatuses');

            this.statusUpdater = setTimeout(this.updateStatuses, 5000)
        }, 
        getShownRowsStatuses(vm) {
            if( vm.value != null ) {
                vm.value.forEach(function(item) {
                    vm.$store.dispatch('powerSocket/sendCommand' , { deviceId: item.deviceId, command: 'STATUS'});
                });
            }
        }
    }
}
</script>
